import React, { useEffect, useState } from "react";
import { X, Sparkles, BadgeCheck } from "lucide-react";

export function MemberCard({ member, compact }) {
  return (
    <div data-testid="member-card" className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-[#005F73] via-[#0A7F8C] to-[#0A9396] p-5 text-white shadow-xl">
      <div aria-hidden className="absolute -right-10 -top-10 h-40 w-40 rounded-full bg-[#EE9B00]/30 blur-2xl" />
      <div className="relative flex items-start justify-between">
        <div className="flex items-center gap-2">
          <img src="/brand/nassau-life-mark-light.png" alt="" className="h-7 w-auto" />
          <div><p className="font-portal text-sm font-extrabold leading-none">Nassau Life</p><p className="text-[10px] font-semibold uppercase tracking-[0.18em] text-white/70">Loyalty Club</p></div>
        </div>
        {member?.is_subscriber && <span data-testid="member-card-subscriber" className="inline-flex items-center gap-1 rounded-full bg-[#EE9B00] px-2 py-0.5 text-[10px] font-bold uppercase text-[var(--p-ink)]"><BadgeCheck size={11} /> Subscriber</span>}
      </div>
      <p className={`font-portal relative font-black tracking-tight ${compact ? "mt-6 text-xl" : "mt-8 text-2xl"}`} data-testid="member-card-name">{member?.name || "Your Name"}</p>
      <p className="relative mt-1 font-mono text-sm tracking-[0.2em] text-white/80" data-testid="member-card-number">{member?.member_no || "NL-000000"}</p>
    </div>
  );
}

function LiveClock() {
  const [now, setNow] = useState(new Date());
  useEffect(() => { const t = setInterval(() => setNow(new Date()), 1000); return () => clearInterval(t); }, []);
  return <span data-testid="claim-live-clock">{now.toLocaleString("en-US", { weekday: "short", month: "short", day: "numeric", hour: "numeric", minute: "2-digit", second: "2-digit" })}</span>;
}

export function ClaimScreen({ claim, member, onClose }) {
  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center bg-[#0B2433]/90 p-4 backdrop-blur" onClick={onClose}>
      <div data-testid="claim-screen" onClick={(e) => e.stopPropagation()} className="w-full max-w-sm overflow-hidden rounded-3xl bg-white shadow-2xl">
        <div className="flex items-center justify-between bg-[#EE9B00] px-5 py-3">
          <p className="flex items-center gap-1.5 text-xs font-extrabold uppercase tracking-wider text-[var(--p-ink)]"><Sparkles size={14} /> Show this to the cashier</p>
          <button onClick={onClose} data-testid="claim-screen-close" aria-label="Close" className="text-[var(--p-ink)]/70 hover:text-[var(--p-ink)]"><X size={20} /></button>
        </div>
        <div className="p-5">
          <MemberCard member={member} compact />
          <div className="mt-5 text-center">
            <p className="text-xs font-bold uppercase tracking-wider text-slate-400">{claim.business_name}</p>
            <p className="font-portal mt-1 text-xl font-extrabold text-[var(--p-ink)]" data-testid="claim-offer-title">{claim.offer_title}</p>
            {claim.discount && <p className="font-portal mt-1 text-3xl font-black text-[var(--p-teal)]">{claim.discount}</p>}
            <div className="mx-auto mt-4 w-fit rounded-xl border-2 border-dashed border-[var(--p-teal)] px-6 py-3">
              <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-slate-400">Redemption code</p>
              <p className="font-mono text-3xl font-black tracking-[0.3em] text-[var(--p-ink)]" data-testid="claim-code">{claim.code}</p>
            </div>
            <p className="mt-4 flex items-center justify-center gap-2 text-xs text-slate-500"><span className="h-2 w-2 animate-pulse rounded-full bg-emerald-500" /> Live · <LiveClock /></p>
          </div>
        </div>
      </div>
    </div>
  );
}
